export default class ContactForm{
    
    constructor(el){
        this.fileFields = el.querySelectorAll('.form__file');
        if (this.fileFields){
            this.files();
        }
    }
    
    files(){
        this.fileFields.forEach((field) =>{
            let fileInput = field.querySelector('input[type="file"]');
            let fileText = field.querySelector('.form__file-text');
            if (fileInput && fileText){
                fileInput.addEventListener('change', (e) => {
                    fileText.innerHTML = fileInput.files[0].name;
                });
            }
        });
    }
}